import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseComponent } from './pages/base/base.component';
import { BreadcrumbGuard } from './core/guards/breadcrumb.guard';

const routes: Routes = [
	{
		path: '',
		component: BaseComponent,
		canActivate: [BreadcrumbGuard],
		children: [
			// {
			// 	path: 'home', children: [
			// 		{ path: '', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),},
			// 	]
			// },
			{ path: '', pathMatch: 'full', redirectTo: 'analytics/overview' },
			{
				path: 'home',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/home/home.module').then((m) => m.HomeModule),
					},
				],
			},
			{
				path: 'cashback',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/cashback/cashback.module').then(
								(m) => m.CashbackModule,
							),
					},
				],
			},
			{
				path: 'overview',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/overview/overview.module').then(
								(m) => m.OverviewModule,
							),
					},
				],
			},
			{
				path: 'analytics/overview',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/overview/overview.module').then(
								(m) => m.OverviewModule,
							),
					},
				],
			},
			{
				path: 'analytics/realtime',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/real-time/real-time.module').then(
								(m) => m.RealTimeModule,
							),
					},
				],
			},
			{
				path: 'analytics/users',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/users/users.module').then((m) => m.UsersModule),
					},
				],
			},
			{
				path: 'analytics/traffic',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/traffic/traffic.module').then(
								(m) => m.TrafficModule,
							),
					},
				],
			},
			{
				path: 'analytics/sessions',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/sessions/sessions.module').then(
								(m) => m.SessionsModule,
							),
					},
				],
			},
			{
				path: 'analytics/trend',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/trend/trend.module').then((m) => m.TrendModule),
					},
				],
			},
			{
				path: 'analytics/monitoring',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/location/location.module').then(
								(m) => m.LocationModule,
							),
					},
				],
			},
			{
				path: 'analytics/ranking',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/location/ranking/ranking.module').then(
								(m) => m.RankingModule,
							),
					},
				],
			},
			{
				path: 'analytics/roaming',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/location/roaming/roaming.module').then(
								(m) => m.RoamingModule,
							),
					},
				],
			},
			{
				path: 'analytics/ranking/:type',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/location/total-ranking/total-ranking.module').then(
								(m) => m.TotalRankingModule,
							),
					},
				],
			},
			{
				path: 'identitiesold',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/clients/clients.module').then(
								(m) => m.ClientsModule,
							),
					},
				],
			},
			{
				path: 'identities',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/identity/identity.module').then(
								(m) => m.IdentityModule,
							),
					},
				],
			},
			{
				path: 'segments',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/segment/segment.module').then(
								(m) => m.SegmentModule,
							),
					},
				],
			},

			{
				path: 'mock',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/mock/mock.module').then((m) => m.MockModule),
					},
				],
			},
			{
				path: 'client_sessions',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/clients/sessions/sessions.module').then(
								(m) => m.SessionModule,
							),
					},
				],
			},
			// {
			// 	path: 'accounts', children: [
			// 		{ path: '', loadChildren: () => import('./pages/managment/account/account-list.module').then(m => m.AccountModule)},
			// 	]
			// },
			{
				path: 'dashboard-accounts',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/managment/account/list/list.module').then(
								(m) => m.AccountListModule,
							),
					},
				],
			},
			{
				path: 'location-group',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/managment/location-group/list/location-group.module').then(
								(m) => m.LocationGroupModule,
							),
					},
				],
			},
			{
				path: 'god-list',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/managment/god-user/list/god-user-list.module').then(
								(m) => m.GodUserModule,
							),
					},
				],
			},
			{
				path: 'invitation',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/passpoint/invitations/invitations.module').then(
								(m) => m.InvitationsModule,
							),
					},
				],
			},
			{
				path: 'troubleshooting/sessions',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/troubleshooting/sessions/sessions.module').then(
								(m) => m.SessionsModule,
							),
					},
				],
			},
			{
				path: 'sessions-page',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/sessions-page/sessions-page.module').then(
								(m) => m.SessionsPageModule,
							),
					},
				],
			},
			{
				path: 'troubleshooting/sessions/:id',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/troubleshooting/sessions/sessions.module').then(
								(m) => m.SessionsModule,
							),
					},
				],
			},
			{
				path: 'troubleshooting/logs',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/troubleshooting/logs/logs.module').then(
								(m) => m.LogsModule,
							),
					},
				],
			},
			{
				path: 'troubleshooting/events',
				children: [
					{
						path: '',
						loadChildren: () =>
							import('./pages/troubleshooting/events/event.module').then(
								(m) => m.EventsModule,
							),
					},
				],
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule { }
